module.exports = __webpack_public_path__ + "img/tp.6710c5bf.png";